import { render, staticRenderFns } from "./GarageList.vue?vue&type=template&id=3974df9a&"
import script from "./GarageList.vue?vue&type=script&lang=js&"
export * from "./GarageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports